// @ts-check
import { Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';
import { formatRupees } from '../../../utils/wholesale';

/** Daily POS (pop-up) sales line for the range, with the sale count and the change on the previous equal period. */
export default function PosBlock({ block }) {
  const { total = 0, count = 0, delta_pct: delta = null, daily = [], awaiting_balance: awaiting } = block.data || {};
  const awaitingCount = (awaiting && awaiting.count) || 0;
  const rounded = delta === null || delta === undefined ? null : Math.round(delta);

  return (
    <BlockCard title="POS" href={block.href} headline={block.headline && { ...block.headline, display: formatRupees(block.headline.value) }}>
      {total > 0 ? (
        <div data-testid="pos-chart" className="overflow-x-auto">
          <LineChart width={320} height={120} data={daily} aria-hidden="true">
            <XAxis dataKey="date" hide />
            <YAxis hide domain={[0, 'auto']} />
            <Tooltip formatter={(v) => [formatRupees(v), 'POS sales']} />
            <Line type="monotone" dataKey="amount" stroke="#3b82f6" strokeWidth={2} dot={false} isAnimationActive={false} />
          </LineChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No POS sales in this range</p>
      )}
      <p className="mt-2 text-sm text-muted-foreground" data-testid="pos-delta">
        {count} {count === 1 ? 'sale' : 'sales'}, {rounded === null ? '—' : `${rounded > 0 ? '+' : ''}${rounded}%`} vs previous period
      </p>
      {awaitingCount > 0 && (
        <p className="mt-1 text-sm text-muted-foreground" data-testid="pos-awaiting">
          {awaitingCount} {awaitingCount === 1 ? 'sale' : 'sales'} awaiting balance ({formatRupees(awaiting.collected || 0)} collected)
        </p>
      )}
    </BlockCard>
  );
}
